import type { Template } from "@/types";

export const PO_07_H1_V6: Template[] = [
    {
        id: "po-07-h1v6-01",
        name: "PO 01 - H1V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h1_v6_01.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 29, y: 223, width: 591, height: 382, rotation: 0, imageRotation: 0 },
            { id: "2", x: 679, y: 134, width: 192, height: 277, rotation: 0, imageRotation: 0 },
            { id: "3", x: 679, y: 419, width: 192, height: 276, rotation: 0, imageRotation: 0 },
            { id: "4", x: 879, y: 134, width: 191, height: 277, rotation: 0, imageRotation: 0 },
            { id: "5", x: 879, y: 419, width: 191, height: 276, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1078, y: 134, width: 191, height: 277, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1078, y: 419, width: 191, height: 276, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h1v6-02",
        name: "PO 02 - H1V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h1_v6_02.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 46, y: 151, width: 553, height: 332, rotation: 0, imageRotation: 0 },
            { id: "2", x: 46, y: 491, width: 133, height: 184, rotation: 0, imageRotation: 0 },
            { id: "3", x: 187, y: 491, width: 132, height: 184, rotation: 0, imageRotation: 0 },
            { id: "4", x: 327, y: 491, width: 132, height: 184, rotation: 0, imageRotation: 0 },
            { id: "5", x: 467, y: 491, width: 132, height: 184, rotation: 0, imageRotation: 0 },
            { id: "6", x: 697, y: 214, width: 273, height: 399, rotation: 0, imageRotation: 0 },
            { id: "7", x: 978, y: 214, width: 272, height: 399, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h1v6-03",
        name: "PO 03 - H1V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h1_v6_03.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 118, y: 113, width: 432, height: 287, rotation: 0, imageRotation: 0 },
            { id: "2", x: 118, y: 408, width: 204, height: 307, rotation: 0, imageRotation: 0 },
            { id: "3", x: 330, y: 408, width: 221, height: 307, rotation: 0, imageRotation: 0 },
            { id: "4", x: 697, y: 113, width: 402, height: 602, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1107, y: 113, width: 143, height: 196, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1107, y: 317, width: 143, height: 195, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1107, y: 520, width: 143, height: 195, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h1v6-04",
        name: "PO 04 - H1V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h1_v6_04.png",
        size: [1298, 827],
        style: {},
        slots: [         
            { id: "1", x: 141, y: 156, width: 180, height: 253, rotation: 0, imageRotation: 0 },
            { id: "2", x: 141, y: 417, width: 180, height: 253, rotation: 0, imageRotation: 0 },
            { id: "3", x: 329, y: 156, width: 179, height: 253, rotation: 0, imageRotation: 0 },
            { id: "4", x: 329, y: 417, width: 179, height: 253, rotation: 0, imageRotation: 0 },
            { id: "5", x: 693, y: 156, width: 291, height: 514, rotation: 0, imageRotation: 0 },
            { id: "6", x: 992, y: 156, width: 259, height: 167, rotation: 0, imageRotation: 0 },
            { id: "7", x: 992, y: 331, width: 259, height: 340, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h1v6-05",
        name: "PO 05 - H1V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h1_v6_05.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 47, y: 233, width: 556, height: 359, rotation: 0, imageRotation: 0 },
            { id: "2", x: 728, y: 102, width: 159, height: 203, rotation: 0, imageRotation: 0 },
            { id: "3", x: 728, y: 313, width: 159, height: 202, rotation: 0, imageRotation: 0 },
            { id: "4", x: 728, y: 523, width: 159, height: 202, rotation: 0, imageRotation: 0 },
            { id: "5", x: 895, y: 102, width: 159, height: 203, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1062, y: 102, width: 158, height: 203, rotation: 0, imageRotation: 0 },
            { id: "7", x: 895, y: 313, width: 325, height: 412, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h1v6-06",
        name: "PO 06 - H1V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h1_v6_06.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 50, y: 113, width: 548, height: 341, rotation: 0, imageRotation: 0 },         
            { id: "2", x: 50, y: 462, width: 178, height: 252, rotation: 0, imageRotation: 0 },
            { id: "3", x: 236, y: 462, width: 177, height: 252, rotation: 0, imageRotation: 0 },
            { id: "4", x: 421, y: 462, width: 177, height: 252, rotation: 0, imageRotation: 0 },
            { id: "5", x: 697, y: 140, width: 366, height: 519, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1071, y: 140, width: 179, height: 256, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1071, y: 404, width: 179, height: 255, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h1v6-07",
        name: "PO 07 - H1V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h1_v6_07.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 125, y: 49, width: 256, height: 361, rotation: 0, imageRotation: 0 },
            { id: "2", x: 389, y: 49, width: 256, height: 361, rotation: 0, imageRotation: 0 },
            { id: "3", x: 653, y: 49, width: 256, height: 361, rotation: 0, imageRotation: 0 },
            { id: "4", x: 917, y: 49, width: 255, height: 361, rotation: 0, imageRotation: 0 },
            { id: "5", x: 125, y: 418, width: 256, height: 360, rotation: 0, imageRotation: 0 },
            { id: "6", x: 917, y: 418, width: 255, height: 360, rotation: 0, imageRotation: 0 },
            { id: "7", x: 389, y: 418, width: 520, height: 360, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h1v6-08",
        name: "PO 08 - H1V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h1_v6_08.png",
        size: [1298, 827],
        style: {},
        slots: [            
            { id: "1", x: 0, y: 161, width: 165, height: 249, rotation: 0, imageRotation: 0 },
            { id: "2", x: 173, y: 161, width: 165, height: 249, rotation: 0, imageRotation: 0 },
            { id: "3", x: 346, y: 161, width: 165, height: 249, rotation: 0, imageRotation: 0 },
            { id: "4", x: 0, y: 418, width: 165, height: 248, rotation: 0, imageRotation: 0 },
            { id: "5", x: 173, y: 418, width: 165, height: 248, rotation: 0, imageRotation: 0 },
            { id: "6", x: 346, y: 418, width: 165, height: 248, rotation: 0, imageRotation: 0 },
            { id: "7", x: 519, y: 161, width: 780, height: 505, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h1v6-09",
        name: "PO 09 - H1V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h1_v6_09.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 597, height: 827, rotation: 0, imageRotation: 0 },
            { id: "2", x: 709, y: 174, width: 528, height: 328, rotation: 0, imageRotation: 0 },
            { id: "3", x: 709, y: 510, width: 100, height: 143, rotation: 0, imageRotation: 0 },
            { id: "4", x: 817, y: 510, width: 99, height: 143, rotation: 0, imageRotation: 0 },
            { id: "5", x: 924, y: 510, width: 99, height: 143, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1031, y: 510, width: 99, height: 143, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1138, y: 510, width: 99, height: 143, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h1v6-10",
        name: "PO 10 - H1V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h1_v6_10.png",
        size: [1298, 827],
        style: {},
        slots: [      
            { id: "1", x: 56, y: 114, width: 138, height: 195, rotation: 0, imageRotation: 0 },
            { id: "2", x: 56, y: 317, width: 138, height: 194, rotation: 0, imageRotation: 0 },
            { id: "3", x: 56, y: 519, width: 138, height: 194, rotation: 0, imageRotation: 0 },
            { id: "4", x: 202, y: 114, width: 892, height: 599, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1102, y: 114, width: 140, height: 195, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1102, y: 317, width: 140, height: 194, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1102, y: 519, width: 140, height: 194, rotation: 0, imageRotation: 0 }
        ],
    }
];